import {Injectable} from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import {forkJoin, Observable} from 'rxjs';
import {CompanyService} from "../global-services/company.service";
import {AccessPermissionsService} from "../layout/access-permissions.service";

@Injectable({
  providedIn: 'root'
})
export class MainRouteResolver implements Resolve<boolean> {
  constructor(private companyService: CompanyService, private accessPermissionsService: AccessPermissionsService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable<boolean>(subscriber => {
      forkJoin({
        company: this.companyService.getOrgDetails(),
        access: this.accessPermissionsService.fetchRolesAndPermissionIfLoggedIn()
      }).subscribe(res=>{
        subscriber.next(true);
        subscriber.complete();
      })
    })
  }
}
